import React from 'react'

const ResourceContext = React.createContext(null)

export const Provider = ResourceContext.Provider
export const Consumer = ResourceContext.Consumer

export default ResourceContext
